module.exports = __webpack_public_path__ + "static/media/poste_26.655d36f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_26.jpg
// module id = 255
// module chunks = 0